import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { RenderDynamicDirective } from '../common/dynamic-components-loader.service';
import { DynamicIconComponent } from '../common/dynamic-icon-loader.component';
import { ShowInEpcotDirective } from '../common/epcot-config.directive';
import { EpcotNotificationComponent } from '../common/epcotNotifications/notification.component';
import { ExpansionPanelComponent } from '../common/expansion-panel/expansion-panel.component';
import { DirectivesModule } from '../directives/directives.module';
import { TabBarModule } from '../tab-bar/tab-bar.module';
import { EmptyMediaComponent } from './empty-media.component';
import { EventSelectorComponent } from './event-selector.component';
import { ScrollToActiveDirective } from './scroll-to-active.directive';
import { UnpinInfoComponent } from './unpin-info.component';
import { VideoPinComponent } from './video-pin.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        ShowInEpcotDirective,
        EpcotNotificationComponent,
        TabBarModule,
        ExpansionPanelComponent,
        IconCustomComponent,
        RenderDynamicDirective,
        DynamicIconComponent,
    ],
    declarations: [EmptyMediaComponent, EventSelectorComponent, VideoPinComponent, ScrollToActiveDirective, UnpinInfoComponent],
    exports: [
        DirectivesModule,
        TabBarModule,
        EmptyMediaComponent,
        EventSelectorComponent,
        VideoPinComponent,
        ScrollToActiveDirective,
        UnpinInfoComponent,
    ],
})
export class MediaComponentsModule {}
